import StudentScoreSummary from './StudentScoreSummary.jsx';
export default StudentScoreSummary;